import { faTruckMonster } from '@fortawesome/free-solid-svg-icons';
import PieChart from '../../../assets/js/Charts/PieChart';
import BarChart from '../../../assets/js/Charts/BarChart';
import apexchart from '../../../../node_modules/vue-apexcharts';

export default {
  name: 'Portfolio',
  components: {
    PieChart,
    BarChart,
    apexchart,
  },
  data() {
    return {
      breakdownByMarketcapChartOptions: {
        width: 100,
        colors: ['#104c99', '#468fec', '#adcef9'],
        labels:["Large", "Medium", "Small"],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 400
            },
            legend: {
              position: 'bottom'
            }
          }
        },
          {
          breakpoint: 560,
          options: {
            chart: {
              width: 500
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        legend: {
          position: 'bottom',
          // inverseOrder: true,
          formatter: function(seriesName, opts) {
            let val = opts.w.globals.series[opts.seriesIndex]
            return ["<span style='display: flex; justify-content: space-between; width: 100px'>"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal"><strong>'+val + '</span></strong>'+ "</span>")]
          }
        },
        plotOptions: {
          pie: {
            startAngle: 90,
            endAngle: -270,
            expandOnClick: false,
            donut: {
              labels: {
                show: false,
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val
                  }
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#373d3f',
                }
              }
            }
          }
        }
      },
      stockDivSeries: [
        {
          name: 'Small',
          data: [
            {
              x: 'Value',
              y: this.getTwoFixedValWithZero(this.sectorSmall.Value),
            },
            {
              x: 'Core',
              y: this.getTwoFixedValWithZero(this.sectorSmall.Core),
            },
            {
              x: 'Growth',
              y: this.getTwoFixedValWithZero(this.sectorSmall.Growth),
            },
            {
              x: 'Not graded',
              y: this.getTwoFixedValWithZero(this.sectorSmall.Undergraded),
            },
          ],
        },
        {
          name: 'Mid',
          data: [
            {
              x: 'Value',
              y: this.getTwoFixedValWithZero(this.sectorMid.Value),
            },
            {
              x: 'Core',
              y: this.getTwoFixedValWithZero(this.sectorMid.Core),
            },
            {
              x: 'Growth',
              y: this.getTwoFixedValWithZero(this.sectorMid.Growth),
            },
            {
              x: 'Not graded',
              y: this.getTwoFixedValWithZero(this.sectorMid.Undergraded),
            },
          ],
        },
        {
          name: 'Large',
          data: [
            {
              x: 'Value',
              y: this.getTwoFixedValWithZero(this.sectorLarge.Value),
            },
            {
              x: 'Core',
              y: this.getTwoFixedValWithZero(this.sectorLarge.Core),
            },
            {
              x: 'Growth',
              y: this.getTwoFixedValWithZero(this.sectorLarge.Growth),
            },
            {
              x: 'Not graded',
              y: this.getTwoFixedValWithZero(this.sectorLarge.Undergraded),
            },
          ],
        },
      ],
      stockDivChartOptions: {
        chart: {
          height: 400,
          type: 'heatmap',
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 300
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '400',
            colors: ['#2E294E'],
          },
          formatter(val, opts) {
            return `${Math.abs(val)}%`;
          },
        },
        colors: ["#468fec"],
        grid: {
          position: 'front',
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        labels: {
          formatter(val, index) {
            return val.toFixed(2);
          },
        },
        xaxis: {
          axisTicks: {
            show: false,
          },
          type: 'category',
          categories: [],
          labels: {
            style: {
              colors: '#737373',
              fontSize: '12px',
              fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
              fontWeight: '400',
            },
          },
        },
        yaxis: {
          tickAmount: 6,
          labels: {
            style: {
              colors: '#737373',
              fontSize: '13px',
              fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
              fontWeight: '400',
            },
          },
        },
        tooltip: {
          shared: false,
          x: {
            formatter(val) {
              return val;
            },
          },
          y: {
            formatter(val) {
              return `${Math.abs(val)}%`;
            },
          },
        },
      },
      holdingsSeries: [{
        data: this.barData.datasets[0].data.map(function(item) {
          return parseFloat(item);
        }).filter(cv => cv != "0")
      }],
      holdingsChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: faTruckMonster,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '600',
            colors: ['#ffffff'],
          },
        },
        xaxis: {
          categories: this.barData.labels,
          labels: {
            style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
                colors: [],
                fontSize: '13px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
      },

      sectorSeries: [
        {
          name: 'Nifty 50',
          data: this.getSectorNiftyData(this.sectorBreakdown),
        },
        {
          name: 'Portfolio',
          data: this.getSectorPortfolioData(this.sectorBreakdown),
        },
      ],
      sectorChartOptions: {
        chart: {
          type: 'bar',
          height: 450,
          toolbar: {
            show: false
          },
        },
        colors: ['#468fec', '#104c99'],
        grid: {
          // position: 'front',
          // xaxis: {
          //   lines: {
          //     show: true,
          //   },
          // },
          // yaxis: {
          //   lines: {
          //     show: true,
          //   },
          // },
        },
        plotOptions: {
          bar: {
            // barHeight: '80%',
            horizontal: false,
            columnWidth: '35%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false,
          // textAnchor: 'middle',
          // position: 'top',
          // formatter(val, opts) {
          //   return `${Math.abs(val)}%`;
          // },
          // offsetX: 40,
          // style: {
          //   fontSize: '12px',
          //   fontFamily: 'Helvetica, Arial, sans-serif',
          //   fontWeight: '400',
          //   colors: ['#2E294E'],
          // },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
          // width: 1,
          // colors: ['#fff'],
        },
        legend: {
          show: false
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            formatter: function(value) {
              return value.toFixed(0) + "%";
            }
          },
        },
        // yaxis: {
        //   axisBorder: {
        //     show: false,
        //   },
        //   min: -100,
        //   max: 100,
        //   title: {
        //     text: '',
        //   },
        //   labels: {
        //     maxWidth: 250,
        //     style: {
        //       colors: '#737373',
        //       fontSize: '12px',
        //       fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
        //       fontWeight: '500',
        //     },
        //   },
        // },
        fill: {
          opacity: 1
        },
        tooltip: {
          // shared: false,
          // x: {
          //   formatter(val) {
          //     return val;
          //   },
          // },
          y: {
            formatter(val) {
              return `${Math.abs(val)}%`;
            },
          },
        },
        xaxis: {
          // axisBorder: {
          //   show: false,
          // },
          // axisTicks: {
          //   show: false,
          // },
          categories: this.getSectorXaxis(this.sectorBreakdown),
          // title: {
          //   text: '',
          // },
          labels: {
            rotate: -90,
            // style: {
            //   colors: '#737373',
            //   fontSize: '5px',
            //   fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial'",
            //   fontWeight: '500',
            // },
            // formatter(val) {
            //   return `${Math.abs(Math.round(val))}%`;
            // },
          },
        },
      },
      breakdownByMarketcapSeries: this.chartData.datasets[0].data.map(function(item) {
        return parseFloat(item, 10);
      }),
      chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
            },
            legend: {
              show: true,
              position: 'bottom',
              horizontalAlign: 'center',
              labels: {
                color: undefined,
                useSeriesColors: true
              },
            },
            labels:["Large", "Mid", "Small"],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
      },


    };
  },
  props: [
    'portfolioData',
    'sectorBreakdown',
    'sectorLarge',
    'sectorMid',
    'sectorSmall',
    'noDataMsg',
    'plotPieData',
    'plotBarData',
    'barData',
    'chartData',
    'initCashPct',
  ],

  methods: {
    getTwoFixedVal(value) {
      if (
        isNaN(value)
        || value == 0
        || value == '-'
        || value == null
        || value == ''
      ) {
        return '-';
      }
      return parseFloat(value).toFixed(2);
    },

    getTwoFixedValWithZero(value) {
      if (isNaN(value) || value == '-' || value == null || value == '') {
        value = 0;
      }
      return parseFloat(value).toFixed(2);
    },

    getUCfirstName(name) {
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    getSectorXaxis(graphData) {
      const xAxisArray = [];
      for (let index = 0; index < 20; index++) {
        if (graphData[index] !== undefined) xAxisArray.push(graphData[index].SectorName);
      }
      return xAxisArray;
    },
    getSectorNiftyData(graphData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (graphData[index] !== undefined) {
          data.push(
            `${this.getTwoFixedValWithZero(graphData[index].pct_nifty50)}`,
          );
        }
      }
      return data;
    },
    getSectorPortfolioData(graphData) {
      const data = [];
      for (let index = 0; index < 20; index++) {
        if (graphData[index] !== undefined) {
          data.push(
            this.getTwoFixedValWithZero(graphData[index].pct_userPortfolio),
          );
        }
      }
      return data;
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Report/Sector.js